import React, { useState } from 'react';
import { Grid } from '@mui/material';
import Button from 'components/atoms/Button';
import { EButtonVariants } from 'constants/Buttons';
import { EIconTypes } from 'constants/Icons';
import { useNavigate } from 'react-router-dom';
import { ERouteLinks } from 'models/route';
import { useApplyWizard } from 'pages/ApplyOnlinePage/ApplyOnlineWizardPage/hooks';
import { ActionTypes } from 'state/actions/alert';
import { EAlertVariants } from 'components/atoms/Alert';
import { useAlert } from 'models/alertContext';
import { StyledFooter, StyledGreenButton } from './styles';

interface IWizardFooter {
  activeStep: number;
  setActiveStep: React.Dispatch<React.SetStateAction<number>>;
  nextHandler: () => void;
  steps: string[];
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const WizardFooter = ({ activeStep, setActiveStep, nextHandler, steps }: IWizardFooter) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { saveApplication } = useApplyWizard();
  const { setAlert } = useAlert();

  const submitApplication = async () => {
    setIsLoading(true);
    const result = await saveApplication();
    if (result.success) {
      setAlert(ActionTypes.SET_NEXT_PAGE_ALERT, {
        text: 'Application has been saved successfully',
        variant: EAlertVariants.success,
      });
      navigate(ERouteLinks.MyApplications);
    }
  };

  return (
    <StyledFooter container>
      <Grid item xs={6} sx={{ marginTop: '10px', paddingLeft: '20px' }}>
        {activeStep > 0 && (
          <Button
            label="Back"
            variant={EButtonVariants.outlined}
            sx={{ marginRight: '20px' }}
            icon={EIconTypes.arrowLeft}
            onClick={() => !isLoading && setActiveStep((prevActiveStep) => prevActiveStep - 1)}
          />
        )}
        <Button
          label="Cancel"
          variant={EButtonVariants.outlined}
          onClick={() => !isLoading && navigate(ERouteLinks.ApplyOnline)}
        />
      </Grid>
      <Grid item xs={6} sx={{ marginTop: '10px', paddingRight: '20px', textAlign: 'right' }}>
        <Button
          label="Save as draft"
          variant={EButtonVariants.text}
          sx={{ marginRight: '20px' }}
        />
        {steps.length === activeStep + 1 ? (
          <StyledGreenButton
            label="Pay and Submit Application"
            isLoading={isLoading}
            onClick={() => submitApplication()}
          />
        ) : (
          <Button label="Next" onClick={() => nextHandler()} />
        )}
      </Grid>
    </StyledFooter>
  );
};

export { WizardFooter };
